function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
//Material imports
import makeStyles from "@mui/styles/makeStyles";
//Limitless imports
import { useTranslation } from "@limitless/common/hooks";
import ExpertDialogueWrapper from "../expert-dialogue-wrapper/ExpertDialogueWrapper";
import ExpertDialogueBody from "../expert-dialogue-body/ExpertDialogueBody";
import ExpertTimePosted from "../expert-time-posted/ExpertTimePosted";
const ExpertTranslatableDialogue = ({
  dialogue,
  ...rest
}) => {
  const {
    created
  } = dialogue;
  const {
    t
  } = useTranslation();
  const classes = useStyles();
  const translatedBody = rest.message.msgClassificationUIControl === "cap_man" ? t("The conversation has been marked as complete. Make sure to complete Classification before you finish the task.") : t("The conversation has been marked as complete. You can now finish the task.");
  return /*#__PURE__*/React.createElement(ExpertDialogueWrapper, _extends({
    shouldAnimate: false,
    dialogue: dialogue
  }, rest), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ExpertDialogueBody, {
    body: translatedBody,
    classes: {
      bodyText: classes.bodyText,
      backgroundColor: classes.background,
      responseListItem: classes.responseListItem
    }
  }), /*#__PURE__*/React.createElement(ExpertTimePosted, {
    dialogue: dialogue,
    time: created
  })));
};
const useStyles = makeStyles(theme => ({
  bodyText: {
    color: theme.palette.secondary.contrastText
  },
  background: {
    backgroundColor: theme.palette.warning.light
  },
  responseListItem: {
    maxWidth: 400
  }
}));
export default ExpertTranslatableDialogue;
ExpertTranslatableDialogue.propTypes = {
  dialogue: PropTypes.object.isRequired
};